import React from "react";
import classNames from "classnames";

const ValueContainerSecondColor = ({
  children,
  fontSize = "13",
  letterSpacing,
  color = "#6F7079",
  className,
}) => {
  return (
    <span
      className={classNames(className)}
      style={{
        fontSize: fontSize + "px",
        color: color,
        letterSpacing: letterSpacing ? letterSpacing : null,
      }}
    >
      {children}
    </span>
  );
};

export default ValueContainerSecondColor;
